module.exports = __webpack_public_path__ + "./../fonts/Linearicons.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/Linearicons.woff2?w118d
 ** module id = 16
 ** module chunks = 0
 **/